import React, {useState} from 'react'
import './header.css'
import Mobile from './mobile'
import Web from './web'



function Header() {
    //state for open or not
    const [isOpen, setIsOpen] = useState(false);
    

    return (
        
        <div className='header'>
            <div className='logo'>Nipuna Peiris</div>
            <div className='menu'>
                <div className='web-menu'>
                    <Web/>
                    
                    
                </div>
                <div className='mobile-menu'>
                    <div onClick={()=>setIsOpen(!isOpen)}>
                        <img className='menu-icon' src='/icon.png'></img>
                    </div>
                    {isOpen && <Mobile isOpen={isOpen} setIsOpen={setIsOpen}/>}
                    
                </div>
            </div>
        </div>
    )
}

export default Header
